import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import moment from "moment";
import { useNavigate, Link } from "react-router-dom";
import "./UserList.css";

const StudyMaterialList = () => {
    document.title = "Study Materials | Uma Classes";

    const [studyMaterials, setStudyMaterials] = useState([]);
    const [modal, setModal] = useState(false);
    const [materialIdToDelete, setMaterialIdToDelete] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudyMaterials = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.get(
                    "https://uma.aasmo.in/api/admin/getall-study-materials",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setStudyMaterials(response || []); // Access the data property
            } catch (error) {
                console.error("Error fetching study materials:", error);
            }
        };

        fetchStudyMaterials();
    }, []);

    const toggleModal = () => setModal(!modal);

    const handleDelete = (materialId) => {
        setMaterialIdToDelete(materialId);
        toggleModal();
    };

    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(
                `https://uma.aasmo.in/api/admin/delete-study-material/${materialIdToDelete}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setStudyMaterials(
                studyMaterials.filter((material) => material._id !== materialIdToDelete)
            );
            toggleModal();
        } catch (error) {
            console.error("Error deleting study material:", error);
        }
    };

    const handleEdit = (materialId) => {
        navigate(`/edit-study-material/${materialId}`);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Study Materials" breadcrumbItem="All" />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title">All Study Materials</h4>
                                    <p className="card-title-desc">Below are all study materials</p>

                                    <div className="table-responsive">
                                        <table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Title</th>
                                                    <th>Category</th>
                                                    <th>Subcategory</th>
                                                    <th>Sub-Subcategory</th>
                                                    <th>Upload Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {studyMaterials.length > 0 ? (
                                                    studyMaterials.map((material, index) => (
                                                        <tr key={material._id}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td className="nowrap">{material.title || "N/A"}</td>
                                                            <td className="nowrap">{material.category?.name || "N/A"}</td>
                                                            <td className="nowrap">{material.subcategory?.name || "N/A"}</td>
                                                            <td className="nowrap">{material.subSubcategory?.name || "N/A"}</td>
                                                            <td className="nowrap">{moment(material.createdAt).format("MMMM Do, YYYY")}</td>
                                                            <td>
                                                                <i
                                                                    className="dripicons-document-edit"
                                                                    onClick={() => handleEdit(material._id)}
                                                                    title="Edit"
                                                                />{" "}
                                                                <i
                                                                    className="dripicons-document-delete"
                                                                    onClick={() => handleDelete(material._id)}
                                                                    title="Delete"
                                                                />{" "}
                                                                <Link to={material.fileUrl}>
                                                                    <i className="dripicons-cloud-download" title="Download" />
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">
                                                            No study materials found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Delete Confirmation Modal */}
                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this study material?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                        <Button color="danger" onClick={confirmDelete}>Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default StudyMaterialList;
